export default __webpack_public_path__ + "static/media/error.58de5b09.svg";